exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-6784e1d6]{margin-top:0;margin-bottom:0}", ""]);

// exports
